import { BookingButton } from "@/components/common/BookingButton";
import { LinkButton } from "@/components/common/LinkButton";
import { CollectiveEndorsement } from "@/components/common/CollectiveEndorsement";
import { Reveal } from "@/components/common/Reveal";

// Full-width closing call-to-action band.
export const CTABand = ({
  eyebrow = "Ready when you are",
  title = "Begin your Legacy Spa experience.",
  lead,
  primary = true,
  secondary,
}) => (
  <section className="relative overflow-hidden bg-legacy-charcoal py-24 md:py-32">
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div
      className="pointer-events-none absolute -right-24 top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-legacy-mint/10 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-medium text-legacy-mint mb-5">
          {eyebrow}
        </p>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
          {title}
        </h2>
        {lead && (
          <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            {lead}
          </p>
        )}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          {primary && <BookingButton size="lg" label="Book an Appointment" testId="cta-book-btn" />}
          {secondary}
        </div>
        <CollectiveEndorsement className="mt-12 justify-center" />
      </Reveal>
    </div>
  </section>
);
